import { render, staticRenderFns } from "./addressAdd.vue?vue&type=template&id=0e516a3a&scoped=true&lang=pug&"
import script from "./addressAdd.vue?vue&type=script&lang=js&"
export * from "./addressAdd.vue?vue&type=script&lang=js&"
import style0 from "./addressAdd.vue?vue&type=style&index=0&id=0e516a3a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e516a3a",
  null
  
)

export default component.exports